import type { ReactNode, SVGProps } from "react";

export function CloseIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="14"
			viewBox="0 0 14 14"
			width="14"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12.958 0.149609C13.0224 0.149648 13.086 0.1631 13.1455 0.187695C13.2052 0.212419 13.26 0.248448 13.3057 0.29414C13.3512 0.339715 13.3874 0.393804 13.4121 0.45332C13.4368 0.512943 13.4502 0.577262 13.4502 0.641796C13.4502 0.706418 13.4368 0.770565 13.4121 0.830273C13.3874 0.889977 13.3514 0.944729 13.3057 0.990429L7.49609 6.8L13.3057 12.6096C13.3514 12.6553 13.3874 12.71 13.4121 12.7697C13.4368 12.8294 13.4502 12.8936 13.4502 12.9582C13.4502 13.0227 13.4368 13.0871 13.4121 13.1467C13.3874 13.2062 13.3512 13.2603 13.3057 13.3059C13.26 13.3516 13.2052 13.3876 13.1455 13.4123C13.086 13.4369 13.0224 13.4504 12.958 13.4504C12.8934 13.4504 12.8292 13.437 12.7695 13.4123C12.7098 13.3876 12.6551 13.3516 12.6094 13.3059L6.7998 7.49629L0.990234 13.3059C0.897955 13.3982 0.772113 13.4504 0.641602 13.4504C0.511215 13.4503 0.38616 13.3981 0.293945 13.3059C0.201731 13.2136 0.149494 13.0886 0.149414 12.9582C0.149403 12.8277 0.201667 12.7019 0.293945 12.6096L6.10352 6.8L0.293945 0.990429C0.201667 0.898135 0.149403 0.772309 0.149414 0.641796C0.149454 0.577261 0.162798 0.512942 0.1875 0.45332C0.212226 0.393803 0.248371 0.339714 0.293945 0.29414C0.339645 0.248448 0.394396 0.21242 0.454102 0.187695C0.513611 0.1631 0.57721 0.149648 0.641602 0.149609C0.772114 0.14962 0.897956 0.201846 0.990234 0.29414L6.7998 6.10371L12.6094 0.29414C12.6551 0.24844 12.7098 0.21243 12.7695 0.187695C12.8292 0.16298 12.8934 0.149614 12.958 0.149609Z"
				fill="currentColor"
				stroke="currentColor"
				strokeWidth="0.3"
			/>
		</svg>
	);
}
